import { render, staticRenderFns } from "./_siteChangesView.vue?vue&type=template&id=b59d6608&scoped=true"
import script from "./_siteChangesView.vue?vue&type=script&lang=js"
export * from "./_siteChangesView.vue?vue&type=script&lang=js"
import style0 from "./_siteChangesView.vue?vue&type=style&index=0&id=b59d6608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59d6608",
  null
  
)

export default component.exports